import React from 'react'

function Reviews() {
  return (
    <div>
      b4
    </div>
  )
}

export default Reviews
